import { LogpayPaymentId } from './payment/logpay/types';

export type PaymentMethod =
  | ILogpayPaymentMethod
  | IKlarnaPaymentMethod
  | IGuestPaymentMethod;

export interface IKlarnaPaymentMethod {
  id: string;
}

export interface IGuestPaymentMethod {
  id: string;
}

export interface ILogpayPaymentMethod {
  id: string;
  type:
    | 'SEPA_DIRECT_DEBIT'
    | 'CREDIT_CARD'
    | 'PAYDIREKT'
    | 'GOOGLE_PAY'
    | 'PAYPAL'
    | 'APPLE_PAY'
    | 'PREPAY'
    | 'AMAZON_PAY'
    | 'BONVOYO';
  stateType: 'CHECKOUT' | 'AUTHORIZATION' | 'ACTIVE' | 'DELETED' | 'GUEST';
  stateTime: string;
  favorite: boolean;
  registered: boolean;
  displayName: string;
  validUntil?: string;
  checkout?: ILogpayCheckout;
  redirectUrl?: string;
}

export interface ILogpayCheckout {
  urlToInitiator: string;
  urlToCancel: string;
  urlToError: string;
}

export type IPurchase = ILogpayPurchase;

export type IRefund = ILogpayRefund;

export interface IPaymentRefundRequest {
  customerId: string;
  transactionId: string;
  amount: number;
}

export interface IPaymentTransactionRequest {
  transactionId: string;
}

export interface IBuyResponse {
  providerResponse: any;
  purchase?: IPurchase;
}

export interface IOnDemandBuyResponse {
  providerResponse: ILogpayCheckoutResponse | ILogpayPaymentResponse;
  purchase?: IPurchase;
}

export interface ILogpayCheckoutResponse {
  redirectUrl: string;
  transactionId?: string;
}

export interface ILogpayPaymentResponse {
  id: string;
  stateType: ELogpayPaymentStatetypes;
}

export enum ELogpayPaymentStatetypes {
  CHECKOUT = 'CHECKOUT',
  AUTHORIZATION = 'AUTHORIZATION',
  RESERVED = 'RESERVED',
  CANCELED = 'CANCELED',
  PURCHASED = 'PURCHASED',
  REJECTED = 'REJECTED',
  REVERSE_PENDING = 'REVERSE_PENDING',
  REVERSED = 'REVERSED',
}

export interface ILogpayPurchase {
  referenceId: string;
  purpose: string;
  purchase: {
    datetime: string;
    currency: 'EUR';
    totalNet: number;
    totalVat: number;
    totalSum: number;
    articles: ITicketForPurchase[];
  };
  paymentMethodId: string;
  urlToInitiator: string;
  urlToCancel: string;
  urlToError: string;
}

export interface ILogpayRefund {
  referenceId: string;
  purpose: string;
  refund: {
    paymentId: LogpayPaymentId;
    currency: 'EUR';
    value: number;
  };
}

export interface ITicketForPurchase {
  id: string;
  name: string;
  number: string;
  position: number;
  quantity: number;
  priceNet: number;
  totalNet: number;
  totalSum: number;
  totalVat: number;
  vat: number;
}
